<template>
	<div style="text-align: center;">
		<h2>你好！{{ userInfo.realName }} </h2>

		<el-form :model="passForm" status-icon :rules="rules" ref="passForm" label-width="100px">
			<el-form-item label="账号">
				<el-input disabled type="text" v-model="userInfo.username"></el-input>
			</el-form-item>
			<el-form-item label="旧密码" prop="currentPass">
				<el-input type="password" v-model="passForm.currentPass" autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="新密码" prop="password">
				<el-input type="password" v-model="passForm.password" autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="确认密码" prop="checkPass">
				<el-input type="password" v-model="passForm.checkPass" autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="submitForm('passForm')">提交</el-button>
				<el-button @click="resetForm('passForm')">重置</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
import { resetPass } from '@/apis/user'
	export default {
		name: "Login",
		data() {
			var validatePass = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请再次输入密码'));
				} else if (value !== this.passForm.password) {
					callback(new Error('两次输入密码不一致!'));
				} else {
					callback();
				}
			};
			return {
				userInfo: {},
				passForm: {
					password: '',
					checkPass: '',
					currentPass: ''
				},
				rules: {
					password: [
						{ required: true, message: '请输入新密码', trigger: 'blur' },
						{ min: 6, max: 12, message: '长度在 6 到 12 个字符', trigger: 'blur' }
					],
					checkPass: [
						{ required: true, validator: validatePass, trigger: 'blur' }
					],
					currentPass: [
						{ required: true, message: '请输入当前密码', trigger: 'blur' },
					]
				}
			}
		},
		created() {
			let username = localStorage.getItem('username')
			let realName = localStorage.getItem('realName')
			this.userInfo =  { username, realName}
		},
		methods: {
			submitForm(formName) {
				let _that = this
				this.$refs[formName].validate((valid) => {
					if (valid) {
						resetPass({
							oldPassword: this.passForm.currentPass,
							newPassword: this.passForm.password
						}).then(res => res.data).then(res => {
							console.log(res);
							if (res.code === 200) {
								this.$notify({
									title: res.message,
									message: '密码修改成功，请重新登录',
									type: 'success',
									onClose: () => {
										localStorage.clear()
										sessionStorage.clear()
										_that.$store.commit("resetState")
										_that.$router.push("/login")
									}
								});
							} else {
								this.$message.error(res.message)
							}
						}).catch(err => {
							console.log(err);
							
							this.$message.error(err.message)
						})

					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			}
		}
	}
</script>

<style scoped>
.el-form {
	width: 420px;
	margin: 50px auto;
}
</style>